var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import React from 'react';
import { Redirect } from 'react-router-dom';
var ErrorBoundary = /** @class */ (function (_super) {
    __extends(ErrorBoundary, _super);
    function ErrorBoundary(props) {
        var _this = _super.call(this, props) || this;
        _this.state = { error: null };
        return _this;
    }
    ErrorBoundary.getDerivedStateFromError = function (error) {
        return { error: error };
    };
    ErrorBoundary.prototype.componentDidCatch = function (error) {
        var _a = this.props, hostServices = _a.hostServices, name = _a.name;
        var currentPath = window.location.pathname.slice(1);
        hostServices.log.error(error);
        hostServices.log.track("ally-next-remote-error-" + name);
        hostServices.log.track("ally-next-remote-error-" + currentPath);
    };
    ErrorBoundary.prototype.render = function () {
        var error = this.state.error;
        var children = this.props.children;
        if (!error)
            return children;
        return React.createElement(Redirect, { to: "/error" });
    };
    return ErrorBoundary;
}(React.Component));
export default ErrorBoundary;
//# sourceMappingURL=index.js.map